"use client";

import React, { useState } from "react";
import { Navigation, X, Map as MapIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
const locations = [{
  id: "alpine-peaks",
  name: "Alpine Peaks",
  address: "Zermatt, Swiss Alps",
  phone: "+41 27 966 8100",
  email: "expeditions@voyage.com",
  x: 48,
  y: 32
}, {
  id: "sahara-dunes",
  name: "Sahara Dunes",
  address: "Merzouga, Morocco",
  phone: "+212 535 577 000",
  email: "adventure@voyage.com",
  x: 45,
  y: 52
}, {
  id: "amazon-basin",
  name: "Amazon Basin",
  address: "Manaus, Brazil",
  phone: "+55 92 3622 1000",
  email: "wildlife@voyage.com",
  x: 28,
  y: 68
}, {
  id: "kyoto-temples",
  name: "Kyoto Temples",
  address: "Higashiyama, Japan",
  phone: "+81 75 561 0001",
  email: "culture@voyage.com",
  x: 82,
  y: 42
}];
export default function MetropolitanPresence() {
  const [activeLocation, setActiveLocation] = useState<string | null>(null);
  return <section data-section-id="222934" id="explore-the-world" className="w-full bg-background text-foreground py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row items-start md:items-end justify-between mb-12 gap-6">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary/10 text-primary mb-6">
              <MapIcon className="w-4 h-4" />
              <span className="text-sm font-medium tracking-widest uppercase font-default">Global Expeditions</span>
            </div>
            <h2 className="text-4xl md:text-5xl lg:text-7xl font-default font-bold text-foreground leading-tight tracking-tighter">
              Explore the <br className="hidden md:block" />
              <span className="text-primary italic">World.</span>
            </h2>
          </div>
          <p className="text-lg text-muted-foreground max-w-md font-default leading-relaxed">
            Embark on curated journeys across the globe. From the peaks of the Alps to the sands of the Sahara, your next story begins here.
          </p>
        </div>

        {}
        <div className="relative w-full h-[500px] md:h-[700px] bg-secondary rounded-2xl overflow-visible shadow-4xl border border-border/30">
          
          {}
          <svg className="absolute inset-0 w-full h-full object-cover opacity-40 pointer-events-none" viewBox="0 0 1000 700" preserveAspectRatio="xMidYMid slice" xmlns="http://www.w3.org/2000/svg">
            <defs>
              <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                <path d="M 40 0 L 0 0 0 40" fill="none" stroke="currentColor" strokeWidth="0.5" className="text-primary/20" />
              </pattern>
            </defs>
            <rect width="100%" height="100%" fill="url(#grid)" />
            
            {}
            <path d="M-100,200 Q150,100 300,300 T800,150 Q950,200 1100,100 L1100,800 L-100,800 Z" fill="currentColor" className="text-primary/5" />
            <path d="M100,-100 Q300,150 500,50 T900,250 1100,-50 L1100,-100 Z" fill="currentColor" className="text-primary/5" />

            {}
            <path d="M480,224 Q465,290 450,364" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeDasharray="4 4" className="opacity-30" />
            <path d="M450,364 Q365,410 280,476" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeDasharray="4 4" className="opacity-30" />
            <path d="M480,224 Q650,250 820,294" fill="none" stroke="var(--primary)" strokeWidth="1.5" strokeDasharray="4 4" className="opacity-30" />
          </svg>

          {}
          {locations.map((loc, i) => <div key={loc.id} data-index={i} className="absolute z-10" style={{
          left: `${loc.x}%`,
          top: `${loc.y}%`
        }}>
              {}
              <Button onClick={() => setActiveLocation(activeLocation === loc.id ? null : loc.id)} variant="ghost" size="icon" className="relative -translate-x-1/2 -translate-y-1/2 focus:outline-none h-auto w-auto p-0" aria-label={`View details for ${loc.name}`}>
                {}
                <div className="absolute inset-0 bg-primary rounded-full animate-ping opacity-40 duration-1000"></div>
                
                {}
                <div className={`relative w-5 h-5 md:w-6 md:h-6 bg-primary rounded-full flex items-center justify-center shadow-lg border-2 border-secondary transition-transform duration-500 ${activeLocation === loc.id ? 'scale-125 rotate-45' : 'hover:scale-110'}`}>
                  <div className="w-1.5 h-1.5 md:w-2 md:h-2 bg-secondary rounded-full"></div>
                </div>
              </Button>

              {}
              {activeLocation === loc.id && <div className={`absolute z-20 left-1/2 -translate-x-1/2 w-72 md:w-80 bg-popover/95 backdrop-blur-xl rounded-xl shadow-4xl border border-border p-5 animate-in fade-in zoom-in-95 duration-300 ${i === 0 ? 'bottom-full mb-4' : 'bottom-full mb-4'}`}>
                  <Button onClick={() => setActiveLocation(null)} variant="ghost" size="icon" className="absolute top-3 right-3 text-muted-foreground hover:text-primary transition-colors bg-muted/50 rounded-full h-8 w-8" aria-label="Close details">
                    <X className="w-4 h-4" />
                  </Button>
                  
                  <div className="pr-6">
                    <h3 className="font-default font-bold text-xl text-popover-foreground mb-1 tracking-tight">{loc.name}</h3>
                    <p className="text-sm text-muted-foreground mb-4 font-default leading-relaxed">{loc.address}</p>
                    
                    <div className="space-y-2 mb-6 bg-accent/50 p-3 rounded-lg border border-border/50">
                      <div className="flex items-center justify-between">
                        <span className="text-[10px] text-muted-foreground font-default uppercase tracking-widest">Inquiries</span>
                        <span className="text-sm text-popover-foreground font-medium font-default">{loc.phone}</span>
                      </div>
                      <div className="flex items-center justify-between">
                        <span className="text-[10px] text-muted-foreground font-default uppercase tracking-widest">Support</span>
                        <span className="text-sm text-popover-foreground font-medium font-default">{loc.email}</span>
                      </div>
                    </div>
                    
                    <Button className="w-full group bg-primary hover:bg-primary/90 text-primary-foreground rounded-full transition-all duration-300" size="default">
                      <Navigation className="w-4 h-4 mr-2 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
                      Plan Expedition
                    </Button>
                  </div>
                  
                  {}
                  <div className={`absolute left-1/2 -translate-x-1/2 w-5 h-5 bg-popover/95 backdrop-blur-xl border-border transform rotate-45 ${i === 0 ? '-bottom-2.5 border-b border-r' : '-bottom-2.5 border-b border-r'}`}></div>
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}